import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const EducationAssumptions = [
  {
    key: 'SchoolName',
    title: 'School Name or Average Selected',
    template: value => value,
  },
  {
    key: 'CostPerYear',
    title: 'Cost Per Year',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    key: 'EnrollmentAge',
    title: 'Enrollment Age',
    template: value => value,
  },
  {
    key: 'NumberOfYearsAttending',
    title: 'Number of Years Attending',
    template: value => value,
  },
  {
    key: 'InflationRate',
    title: 'Inflation Rate',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'AdditionalMonthlySavings',
    title: 'Additional Monthly Savings',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    key: 'AssetAllocation',
    title: 'Asset Allocation',
    template: value => value,
  },
  {
    key: 'RateOfReturn',
    title: 'Rate of Return',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'EarmarkedAssets',
    title: 'Earmarked Assets',
    template: value => `${formatAsCurrency(value)}`,
  },
];

export default EducationAssumptions;
